import { FC, useState } from 'react';
import Observer from '@researchgate/react-intersection-observer';

const DeferRender: FC = ({ children }) => {
  const [isVisibile, setIsVisibile] = useState(false);
  return (
    <Observer
      threshold={[0, 1]}
      onChange={({ isIntersecting }) => {
        setIsVisibile(isIntersecting);
      }}
    >
      <div>{isVisibile ? children : null}</div>
    </Observer>
  );
};

export default DeferRender;
